import {
    getBrandList,
    getCategoriesList,
    getClientFormats,
    getDashboardsList,
    getDashboardsResumeInfo,
    getSectionView,
    getSelectedClient,
    getUserStoresAllList,
    isLoadingBrands,
    isLoadingCategories,
    isLoadingClientFormats,
    isLoadingDashboards,
    isLoadingExcelDownload,
    isLoadingResumeDashboards,
    isLoadingUserStores,
    isLoadingUserSuppliers,
    loadingDashboardResume,
    userSuppliers,
} from 'core/selectors';
import { getDashboardResume, getDashboards } from 'core/slices/dashboards';
import { downloadExcel } from 'core/slices/general';
import { getNumberFormat, getStoreBrands, getStoreCategories } from 'core/slices/store';
import { getUserStores, getUserSuppliers } from 'core/slices/users';
import { connect } from 'react-redux';

import Home from '../../../components/features/home/Home';

export default connect(state => ({
    isLoadingUserStores: isLoadingUserStores(state),
    isLoadingResumeDashboards: isLoadingResumeDashboards(state),
    isLoadingDashboards: isLoadingDashboards(state),
    loadingDashboardResume: loadingDashboardResume(state),
    dashboardsResume: getDashboardsResumeInfo(state),
    dashboardsList: getDashboardsList(state),
    sectionsView: getSectionView(state),
    userStores: getUserStoresAllList(state),
    selectedClient: getSelectedClient(state),
    isLoadingBrands: isLoadingBrands(state),
    isLoadingCategories: isLoadingCategories(state),
    storeCategories: getCategoriesList(state),
    brandList: getBrandList(state),
    isLoadingExcelDownload: isLoadingExcelDownload(state),
    suppliers: userSuppliers(state),
    isLoadingSuppliers: isLoadingUserSuppliers(state),
    clientFormats: getClientFormats(state),
    isLoadingClientFormats: isLoadingClientFormats(state),
}), {
    downloadExcel,
    getDashboards,
    getUserStores,
    getStoreBrands,
    getStoreCategories,
    getDashboardResume,
    getNumberFormat,
    getUserSuppliers,
})(Home);
